import React, { useEffect, useState } from 'react';
import { Download, X } from 'lucide-react';

/**
 * Banner que sugere instalar o app no celular.
 * Aparece automaticamente quando o navegador permite (Android/Chrome).
 * Pra iOS, mostra instrução manual ("Compartilhar → Adicionar à Tela Inicial").
 */
const InstallPWABanner = () => {
  const [deferredPrompt, setDeferredPrompt] = useState(null);
  const [show, setShow] = useState(false);
  const [isIOS, setIsIOS] = useState(false);

  useEffect(() => {
    // Já dispensado nesta sessão?
    if (sessionStorage.getItem('pwa_banner_dismissed') === '1') return;

    // Já instalado?
    if (window.matchMedia('(display-mode: standalone)').matches || window.navigator.standalone) {
      return;
    }

    // iOS detection
    const ua = window.navigator.userAgent.toLowerCase();
    const isIos = /iphone|ipad|ipod/.test(ua) && !window.MSStream;
    if (isIos) {
      setIsIOS(true);
      // Mostra após 4s
      const t = setTimeout(() => setShow(true), 4000);
      return () => clearTimeout(t);
    }

    // Android/Chrome: captura evento beforeinstallprompt
    const handler = (e) => {
      e.preventDefault();
      setDeferredPrompt(e);
      setShow(true);
    };
    window.addEventListener('beforeinstallprompt', handler);
    return () => window.removeEventListener('beforeinstallprompt', handler);
  }, []);

  const instalar = async () => {
    if (!deferredPrompt) return;
    deferredPrompt.prompt();
    const { outcome } = await deferredPrompt.userChoice;
    if (outcome === 'accepted') {
      setShow(false);
    }
    setDeferredPrompt(null);
  };

  const dispensar = () => {
    sessionStorage.setItem('pwa_banner_dismissed', '1');
    setShow(false);
  };

  if (!show) return null;

  return (
    <div
      data-testid="pwa-install-banner"
      className="fixed bottom-20 left-3 right-3 sm:left-auto sm:right-4 sm:bottom-4 sm:max-w-sm bg-gradient-to-br from-[#E2B84A] to-[#C9A03D] rounded-2xl p-4 shadow-[0_8px_30px_rgba(226,184,74,0.5)] z-40 text-white"
    >
      <button
        onClick={dispensar}
        className="absolute top-2 right-2 text-white/70 hover:text-white"
        data-testid="pwa-banner-close"
        aria-label="Fechar"
      >
        <X size={18} />
      </button>
      <div className="flex items-start gap-3">
        <div className="bg-white/20 rounded-full p-2 shrink-0">
          <Download size={20} className="text-white" />
        </div>
        <div className="flex-1 min-w-0 pr-4">
          <p className="font-bold text-sm" style={{ fontFamily: 'Outfit, sans-serif' }}>
            Instalar Giraia Bike Shop no celular
          </p>
          {isIOS ? (
            <p className="text-white/90 text-xs mt-1">
              No Safari, toca no botão <strong>Compartilhar</strong> ⬆️ e depois em
              <strong> "Adicionar à Tela Inicial"</strong>.
            </p>
          ) : (
            <p className="text-white/90 text-xs mt-1">
              Tenha acesso rápido como um app de verdade.
            </p>
          )}
        </div>
      </div>
      {!isIOS && deferredPrompt && (
        <button
          onClick={instalar}
          data-testid="pwa-install-button"
          className="mt-3 w-full bg-white text-[#C9A03D] font-black rounded-lg py-2 hover:bg-[#FFD700] transition-colors text-sm"
        >
          📱 Instalar agora
        </button>
      )}
    </div>
  );
};

export default InstallPWABanner;
